import { LINK } from '@/constants';
import { AccountPlan } from '@/constants/enum';
import { isLockFeature } from '@/helpers/feature';
import { tokenSelector } from '@/redux/features/auth.slice';
import getRouteList from '@/routes/routes';
import { Navigation } from '@shopify/polaris';
import { QuestionCircleIcon } from '@shopify/polaris-icons';
import { ItemProps } from '@shopify/polaris/build/ts/src/components/Navigation/types';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import useTrackingPageUrl from '@/hooks/useTrackingPageUrl';
import { StyledNavigation } from './styled';

const Sidebar = () => {
  const { shop } = useSelector(tokenSelector);
  const { proxyPath } = useTrackingPageUrl();
  const shopName = shop.split('.')[0] || '';
  const { pathname } = useLocation();
  const isShowLockIcon = !isLockFeature([AccountPlan.Starter]);

  const topSidebarItems = getRouteList(proxyPath)
    .filter(({ hiddenInSidebar }) => !hiddenInSidebar)
    .map(({ name, path, icon, actionIcon }) => {
      let navigationItem: ItemProps = { url: path, label: name || '', icon };

      if (actionIcon) {
        navigationItem = { ...navigationItem, secondaryActions: [{ ...actionIcon }] };
      }

      return navigationItem;
    });

  const renderBottomSidebar = (): ItemProps[] => {
    const openHelpCenter = () => window.open(LINK.HELP_CENTER);

    return [
      {
        label: 'Help Center',
        icon: QuestionCircleIcon,
        onClick: openHelpCenter,
      },
    ];
  };

  return (
    <StyledNavigation isShowLockIcon={isShowLockIcon}>
      <Navigation location={pathname}>
        <Navigation.Section title={`${shopName}`} items={topSidebarItems} />
        <Navigation.Section items={renderBottomSidebar()} />
      </Navigation>
    </StyledNavigation>
  );
};

export default Sidebar;
